import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

// Product images
const PRODUCT_IMAGES = {
  'diet-fuel-cocoa': '/images/diet-fuel-cocoa/main.png',
  'diet-fuel-coconut': '/images/diet-fuel-coconut/main.png',
  'bpc-157': '/images/bpc-157/bpc-vial.png',
  'ghk-cu': '/images/ghk-cu/ghk-cu-50-main.png',
  'nad-plus': '/images/nad-plus/nad-vial.png',
  'tb500': '/images/tb500/tb500-vial.png',
  'magnesium-glycinate': '/images/magnesium/mag-main.png',
  'mots-c': '/images/mots-c/mots-25-main.png',
  'aod-9604': '/images/aod-9604/aod-main.png',
  'bioglutide': '/images/bioglutide/bio-main.png',
  'dsip': '/images/dsip/dsip-main.png',
  'kisspeptin': '/images/kisspeptin/kiss-main.png',
  'll-37': '/images/ll-37/ll37-main.png',
  'selank': '/images/selank/selank-main.png',
  'semax': '/images/semax/semax-main.png',
  'slu-pp-332': '/images/slu-pp-332/slu-main.png',
  'ss-31': '/images/ss-31/ss31-main.png',
  'vilon': '/images/vilon/vilon-main.png',
  'vip': '/images/vip/vip-main.png',
  'retatrutide': '/images/retatrutide/reta-20-main.png',
  'revigen': '/images/revigen/revigen-main.png',
  'glow': '/images/glow/glow-main.png',
  'bpc157-tb500-tablets': '/images/bpc157-tb500-tablets/main.png',
  'gnc-fish-oil': '/images/gnc-fish-oil/main.png',
  'bac-water': '/images/bac-water/main.png',
};

// Products data - Updated prices to ₹5,000
const products = [
  // Peptides - Toro Pharma
  { id: 'bpc-157-toro', name: 'BPC-157', brand: 'Toro Pharma', price: '₹6,500', category: 'peptides', subCategory: 'toro-pharma', image: PRODUCT_IMAGES['bpc-157'], slug: 'bpc-157' },
  { id: 'nad-plus-toro', name: 'NAD+', brand: 'Toro Pharma', price: '₹5,500', category: 'peptides', subCategory: 'toro-pharma', image: PRODUCT_IMAGES['nad-plus'], slug: 'nad-plus' },
  { id: 'tb500-toro', name: 'TB500', brand: 'Toro Pharma', price: '₹7,000', category: 'peptides', subCategory: 'toro-pharma', image: PRODUCT_IMAGES['tb500'], slug: 'tb500' },
  { id: 'mots-c-toro', name: 'MOTS-C', brand: 'Toro Pharma', price: '₹7,500', category: 'peptides', subCategory: 'toro-pharma', image: PRODUCT_IMAGES['mots-c'], slug: 'mots-c' },
  { id: 'aod-9604-toro', name: 'AOD-9604', brand: 'Toro Pharma', price: '₹3,000', category: 'peptides', subCategory: 'toro-pharma', image: PRODUCT_IMAGES['aod-9604'], slug: 'aod-9604' },
  { id: 'bioglutide-toro', name: 'BIOGLUTIDE', brand: 'Toro Pharma', price: '₹12,000', category: 'peptides', subCategory: 'toro-pharma', image: PRODUCT_IMAGES['bioglutide'], slug: 'bioglutide' },
  { id: 'dsip-toro', name: 'DSIP', brand: 'Toro Pharma', price: '₹4,000', category: 'peptides', subCategory: 'toro-pharma', image: PRODUCT_IMAGES['dsip'], slug: 'dsip' },
  { id: 'kisspeptin-toro', name: 'KISSPEPTIN', brand: 'Toro Pharma', price: '₹8,000', category: 'peptides', subCategory: 'toro-pharma', image: PRODUCT_IMAGES['kisspeptin'], slug: 'kisspeptin' },
  { id: 'll-37-toro', name: 'LL-37', brand: 'Toro Pharma', price: '₹4,000', category: 'peptides', subCategory: 'toro-pharma', image: PRODUCT_IMAGES['ll-37'], slug: 'll-37' },
  { id: 'selank-toro', name: 'SELANK', brand: 'Toro Pharma', price: '₹4,000', category: 'peptides', subCategory: 'toro-pharma', image: PRODUCT_IMAGES['selank'], slug: 'selank' },
  { id: 'semax-toro', name: 'SEMAX', brand: 'Toro Pharma', price: '₹5,000', category: 'peptides', subCategory: 'toro-pharma', image: PRODUCT_IMAGES['semax'], slug: 'semax' },
  { id: 'slu-pp-332-toro', name: 'SLU-PP-332', brand: 'Toro Pharma', price: '₹5,000', category: 'peptides', subCategory: 'toro-pharma', image: PRODUCT_IMAGES['slu-pp-332'], slug: 'slu-pp-332' },
  { id: 'ss-31-toro', name: 'SS-31', brand: 'Toro Pharma', price: '₹5,500', category: 'peptides', subCategory: 'toro-pharma', image: PRODUCT_IMAGES['ss-31'], slug: 'ss-31' },
  { id: 'vilon-toro', name: 'VILON', brand: 'Toro Pharma', price: '₹5,300', category: 'peptides', subCategory: 'toro-pharma', image: PRODUCT_IMAGES['vilon'], slug: 'vilon' },
  { id: 'vip-toro', name: 'VIP', brand: 'Toro Pharma', price: '₹5,300', category: 'peptides', subCategory: 'toro-pharma', image: PRODUCT_IMAGES['vip'], slug: 'vip' },
  { id: 'retatrutide-toro', name: 'RETATRUTIDE', brand: 'Toro Pharma', price: '₹12,000', category: 'peptides', subCategory: 'toro-pharma', image: PRODUCT_IMAGES['retatrutide'], slug: 'retatrutide' },
  { id: 'revigen-toro', name: 'REVIGEN', brand: 'Toro Pharma', price: '₹13,000', category: 'beauty', subCategory: 'toro-pharma', image: PRODUCT_IMAGES['revigen'], slug: 'revigen' },
  { id: 'glow-toro', name: 'GLOW', brand: 'Toro Pharma', price: '₹10,500', category: 'beauty', subCategory: 'toro-pharma', image: PRODUCT_IMAGES['glow'], slug: 'glow' },
  { id: 'ghk-cu-beauty', name: 'GHK-Cu', brand: 'Toro Pharma', price: '₹12,000', category: 'beauty', subCategory: 'toro-pharma', image: PRODUCT_IMAGES['ghk-cu'], slug: 'ghk-cu' },
  { id: 'bpc157-tb500-tablets-toro', name: 'BPC 157 + TB500', brand: 'Toro Pharma', price: '₹5,850', category: 'supplements', subCategory: 'toro-pharma', image: PRODUCT_IMAGES['bpc157-tb500-tablets'], slug: 'bpc157-tb500-tablets' },
  { id: 'gnc-fish-oil-gnc', name: 'GNC Fish Oil 1000 mg', brand: 'GNC', price: '₹599', category: 'supplements', subCategory: 'gnc', image: PRODUCT_IMAGES['gnc-fish-oil'], slug: 'gnc-fish-oil' },
  { id: 'bac-water-toro', name: 'Bacteriostatic Water 10ml', brand: 'Toro Pharma', price: '₹600', category: 'peptides', subCategory: 'toro-pharma', image: PRODUCT_IMAGES['bac-water'], slug: 'bac-water' },
  
  // Supplements
  { id: 'magnesium-glycinate', name: 'Magnesium Glycinate', brand: 'Carbamide Forte', price: '₹500', category: 'supplements', subCategory: null, image: PRODUCT_IMAGES['magnesium-glycinate'], slug: 'magnesium-glycinate' },
  
  // Diet Fuel
  { id: 'diet-fuel-cocoa', name: 'Diet Fuel Cocoa', brand: 'Life Reversal', price: '₹455', category: 'diet-fuel', subCategory: null, image: PRODUCT_IMAGES['diet-fuel-cocoa'], slug: 'diet-fuel-cocoa' },
  { id: 'diet-fuel-coconut', name: 'Diet Fuel Coconut Macadamia', brand: 'Life Reversal', price: '₹600', category: 'diet-fuel', subCategory: null, image: PRODUCT_IMAGES['diet-fuel-coconut'], slug: 'diet-fuel-coconut' },
];

const filterTabs = [
  { id: 'all', label: 'All Products' },
  { id: 'peptides', label: 'Peptides' },
  { id: 'supplements', label: 'Supplements' },
  { id: 'diet-fuel', label: 'Diet Fuel' },
  { id: 'beauty', label: 'Beauty' },
];

const peptideSubTabs = [
  { id: 'toro-pharma', label: 'Toro Pharma' },
];

const getBrandLabel = (brand) => {
  switch (brand) {
    case 'Toro Pharma': return 'TORO PHARMA';
    case 'Biomolecules': return 'BIOMOLECULES';
    case 'Denik': return 'DENIK';
    case 'Carbamide Forte': return 'CARBAMIDE FORTE';
    case 'Life Reversal': return 'LIFE REVERSAL';
    default: return brand.toUpperCase();
  }
};

const ProductCard = ({ product }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/product/${product.slug}`);
  };

  return (
    <div 
      data-testid={`product-card-${product.id}`}
      className="group relative flex flex-col h-full bg-white transition-all duration-300 hover:shadow-md cursor-pointer"
      style={{ 
        borderRadius: '4px',
        transform: 'translateY(0)',
      }}
      onClick={handleClick}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-4px)';
        e.currentTarget.style.boxShadow = '0 12px 24px rgba(0, 0, 0, 0.08)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      {/* Brand Label - Top Left */}
      <div 
        className="absolute top-3 left-3 z-10 px-2 py-1"
        style={{ 
          backgroundColor: '#000000',
          borderRadius: '3px',
        }}
      >
        <span 
          className="text-[9px] font-medium uppercase"
          style={{ color: '#FFFFFF', letterSpacing: '0.06em' }}
        >
          {getBrandLabel(product.brand)}
        </span>
      </div>
      
      {/* Image Area */}
      <div 
        className="w-full flex items-center justify-center"
        style={{ backgroundColor: '#FFFFFF', height: '240px', padding: '20px 28px', paddingTop: '36px' }}
      >
        {product.image && (
          <picture style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
            <source srcSet={product.image.replace(/\.(png|jpg|jpeg|PNG)$/i, '.webp')} type="image/webp" />
            <img 
              src={product.image} 
              alt={product.name}
              loading="lazy"
              className="transition-transform duration-300 group-hover:scale-105"
              style={{ 
                objectFit: 'contain', 
                objectPosition: 'center',
                maxWidth: '100%',
                maxHeight: '100%',
                width: 'auto',
                height: 'auto',
              }}
            />
          </picture>
        )}
      </div>
      
      {/* Product Info - Fixed Structure */}
      <div className="flex flex-col flex-grow px-5 pb-5 pt-3">
        {/* Product Name */}
        <h3 
          className="text-sm font-medium mb-1.5 line-clamp-2"
          style={{ color: '#2B2B2B', minHeight: '40px' }}
        >
          {product.name}
        </h3>
        
        {/* Price */}
        <p 
          className="text-base font-semibold mb-4"
          style={{ color: '#2B2B2B' }}
        >
          {product.price}
        </p>
        
        {/* CTA - View Product */}
        <span
          data-testid={`view-product-${product.id}`}
          className="inline-flex items-center gap-1.5 text-sm font-medium transition-all duration-200 hover:opacity-70 mt-auto"
          style={{ color: '#1A3D36' }}
        >
          View Product
          <ArrowRight size={14} strokeWidth={2} />
        </span>
      </div>
    </div>
  );
};

export const ProductSection = () => {
  const [activeFilter, setActiveFilter] = useState('all');
  const [activePeptideSubFilter, setActivePeptideSubFilter] = useState('toro-pharma');

  const getFilteredProducts = () => {
    if (activeFilter === 'all') {
      return products;
    }
    
    if (activeFilter === 'peptides') {
      return products.filter(p => p.category === 'peptides' && p.subCategory === activePeptideSubFilter);
    }
    
    return products.filter(p => p.category === activeFilter);
  };

  const filteredProducts = getFilteredProducts().filter(p => p.image && p.name && p.price);

  return (
    <section 
      id="products-section"
      data-testid="products-section"
      className="w-full py-20 lg:py-28"
      style={{ backgroundColor: '#F5F2EB' }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 
            className="font-serif text-3xl lg:text-4xl mb-4"
            style={{ color: '#2B2B2B' }}
          >
            Shop Products
          </h2>
          <p 
            className="text-base max-w-xl mx-auto"
            style={{ color: '#6B6B6B' }}
          >
            Premium peptides, targeted supplements, and nutrition systems for optimal performance.
          </p>
        </div>

        {/* Filter Tabs */}
        <div 
          data-testid="filter-tabs"
          className="flex flex-wrap justify-center gap-3 mb-8"
        >
          {filterTabs.map(tab => (
            <button
              key={tab.id}
              data-testid={`filter-${tab.id}`}
              onClick={() => {
                setActiveFilter(tab.id);
                if (tab.id === 'peptides') {
                  setActivePeptideSubFilter('toro-pharma');
                }
              }}
              className="px-6 py-2.5 text-sm font-medium rounded-full transition-all duration-200"
              style={{
                backgroundColor: activeFilter === tab.id ? '#0B1F14' : '#FFFFFF',
                color: activeFilter === tab.id ? '#FFFFFF' : '#2B2B2B',
                border: activeFilter === tab.id ? 'none' : '1px solid #D9D6CF',
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Peptide Sub-Tabs */}
        {activeFilter === 'peptides' && (
          <div 
            data-testid="peptide-sub-tabs"
            className="flex justify-center gap-8 mb-12"
          >
            {peptideSubTabs.map(tab => (
              <button
                key={tab.id}
                data-testid={`peptide-sub-${tab.id}`}
                onClick={() => setActivePeptideSubFilter(tab.id)}
                className="relative pb-2 text-sm font-medium transition-all duration-200"
                style={{
                  color: activePeptideSubFilter === tab.id ? '#2B2B2B' : '#6B6B6B',
                }}
              >
                {tab.label}
                {/* Active underline */}
                <span 
                  className="absolute bottom-0 left-0 w-full h-0.5 transition-all duration-200"
                  style={{
                    backgroundColor: '#1A3D36',
                    transform: activePeptideSubFilter === tab.id ? 'scaleX(1)' : 'scaleX(0)',
                  }}
                />
              </button>
            ))}
          </div>
        )}

        {/* Product Grid */}
        <div 
          data-testid="product-grid"
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
        >
          {filteredProducts.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductSection;
